import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { eventTypeNames } from 'donor-elf-web/lib/event-type-names';
import EventModel from 'donor-elf-web/models/event';
import Contact from 'donor-elf-web/components/contact';
import formatDate from 'donor-elf-web/helpers/format-date';
import { on } from '@ember/modifier';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import EventInfoNewDonorComponent from 'donor-elf-web/components/event/info/new-donor';
import EventInfoLateDonorComponent from 'donor-elf-web/components/event/info/late-donor';
import EventInfoStoppedGivingDonorComponent from 'donor-elf-web/components/event/info/stopped-giving-donor';
import EventInfoChangedComponent from 'donor-elf-web/components/event/info/info-changed';
import EventInfoNewMonthlyDonorComponent  from 'donor-elf-web/components/event/info/new-monthly-donor';
import EventInfoNewPledgeComponent from 'donor-elf-web/components/event/info/new-pledge';
import EventInfoAboveRegularAmountComponent from 'donor-elf-web/components/event/info/above-regular-amount';
import EventInfoBelowRegularAmountComponent from 'donor-elf-web/components/event/info/below-regular-amount';
import EventInfoReturningLateDonorComponent from 'donor-elf-web/components/event/info/returning-late-donor';
import EventInfoReturningStoppedGivingDonorComponent from 'donor-elf-web/components/event/info/returning-stopped-giving-donor';
import EventInfoCatchupGiftComponent from 'donor-elf-web/components/event/info/catchup-gift';
import EventInfoExtraGiftComponent from 'donor-elf-web/components/event/info/extra-gift';
import EventInfoExpiringPledgeComponent from 'donor-elf-web/components/event/info/expiring-pledge';
import EventInfoUnthankedDonorComponent from 'donor-elf-web/components/event/info/unthanked-donor';
import EventInfoAskForIncreaseComponent from 'donor-elf-web/components/event/info/ask-for-increase';

interface ComponentArgs {
  eventModel: EventModel;
  showContact?: boolean;
}

export default class EventIndexComponent extends Component<ComponentArgs> {
  get showContact() {
    return this.args.showContact ?? true;
  }

  @tracked showInfo = false;

  get eventName() {
    return eventTypeNames[this.args.eventModel.eventTypeId];
  }

  get eventColorClass() {
    return EventColorName[this.args.eventModel.eventTypeId];
  }

  get eventInfoComponent() {
    return eventComponentMap[this.args.eventModel.eventTypeId];
  }

  toggleInfo = () => {
    this.showInfo = !this.showInfo;
  }

  <template>
    <div class='event-item {{this.eventColorClass}}'>
      <div class='{{if this.showContact "event-shows-contact"}} d-flex'>
        <div>
          <div class='event-name'>
            <strong>{{this.eventName}}</strong>
            <span class='text-muted font-weight-light'>on
              {{formatDate @eventModel.occurredAt}}</span>
          </div>
          {{#if this.showContact}}
            <Contact @contactId={{@eventModel.contactId}} class='event-contact' />
          {{/if}}
        </div>
        <div
          {{on 'click' this.toggleInfo}}
          class='ml-auto event-toggle-info cursor-pointer'
          role='button'
        >
          <span>{{svgJar 'info'}}</span>
        </div>
      </div>
      <div class='event-info {{unless this.showInfo "d-none"}}'>
        {{#if this.showInfo}}
          <this.eventInfoComponent @eventModel={{@eventModel}} />
        {{/if}}
      </div>
    </div>
  </template>
}

const EventColorName: { [typeId: number]: string } = {
  1: 'good-event',
  2: 'bad-event',
  3: 'bad-event',
  4: 'info-event',
  5: 'good-event',
  8: 'good-event',
  9: 'good-event',
  10: 'bad-event',
  11: 'good-event',
  12: 'good-event',
  13: 'good-event',
  14: 'good-event',
  15: 'info-event',
  16: 'bad-event',
  17: 'info-event',
};

const eventComponentMap: Record<number, any> = {
  1: EventInfoNewDonorComponent,
  2: EventInfoLateDonorComponent,
  3: EventInfoStoppedGivingDonorComponent,
  4: EventInfoChangedComponent,
  5: EventInfoNewMonthlyDonorComponent,
  8: EventInfoNewPledgeComponent,
  9: EventInfoAboveRegularAmountComponent,
  10: EventInfoBelowRegularAmountComponent,
  11: EventInfoReturningLateDonorComponent,
  12: EventInfoReturningStoppedGivingDonorComponent,
  13: EventInfoCatchupGiftComponent,
  14: EventInfoExtraGiftComponent,
  15: EventInfoExpiringPledgeComponent,
  16: EventInfoUnthankedDonorComponent,
  17: EventInfoAskForIncreaseComponent
}

export interface EventInfoComponentArgs {
  eventModel: EventModel;
}
